// import React, { useState } from "react";
// import { FormikProvider, useFormik, Form } from "formik";
// import * as Yup from "yup";
// import {
//   Button,
//   CardContent,
//   CardActions,
//   Card,
//   TextField,
//   Box,
//   Stack,
//   Grid,
//   Typography,
//   Container,
//   Divider,
//   MenuItem,
//   FormControl,
//   FormLabel,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Link
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { LoadingButton } from "@mui/lab";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { Post, apiURL } from "../../../utils/apiCalls";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import BusinessIcon from "@mui/icons-material/Business";
// import DownloadIcon from "@mui/icons-material/Download";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// // =========================
// // CONFIG: dynamic field map
// // =========================
// export const FORM_CONFIG = {
//   farmland: {
//     title: "Farmland Plots Procurement Checklist",
//     fields: [
//       { name: "company_name", label: "Company Name", type: "text", required: true },
//       { name: "project_name", label: "Project Name", type: "text", required: true },
//       { name: "project_location", label: "Project Location", type: "text", required: true },
//       { name: "highways", label: "Which highways are the projects for?", type: "text" },
//       { name: "project_brochures", label: "Project Brochures", type: "file" },
//       { name: "project_videos", label: "Project Videos & Photos", type: "file" },
//       { name: "linked_documents", label: "Linked Documents", type: "file" },
//       { name: "development_progress", label: "How far has the development progressed?", type: "select", options: ["0-10%", "10-25%", "25-50%", "50-75%", "75-100%"] },
//       { name: "is_own_land", label: "Is this the company's own land?", type: "radio", options: ["Yes", "No"] },
//       { name: "is_own_venture", label: "Is this a company-owned venture?", type: "radio", options: ["Yes", "No"] },
//       { name: "nala_conversion", label: "Will you do NALA conversion?", type: "radio", options: ["Yes", "No"] },
//       { name: "registrations", label: "How many people register?", type: "number" },
//       { name: "bank_loan", label: "Will I get a bank loan?", type: "radio", options: ["Yes", "No"] },
//       { name: "associate_highest_commission", label: "What is the highest commission in the company?", type: "number" },
//       { name: "plp_margin", label: "How much commission is given to PERFECT LAYOUT PVT LTD?", type: "number" },
//     ]
//   },
//   open_plots: {
//     title: "Open Plots Project Procurement Checklist",
//     fields: [
//       { name: "company_name", label: "Company Name", type: "text" },
//       { name: "project_name", label: "Project Name", type: "text" },
//       { name: "project_location", label: "Project Location", type: "text" },
//       { name: "project_type", label: "Project Type", type: "select", options: ["DTCP", "HMDA", "FARM LAND"] },
//       { name: "highways", label: "Which highways are the projects for?", type: "text" },
//       { name: "rera_number", label: "RERA Number", type: "text" },
//       { name: "rera_certificate", label: "RERA Certificate", type: "file" },
//       { name: "lp_number", label: "LP Number", type: "text" },
//       { name: "project_brochures", label: "Project Brochures", type: "file" },
//       { name: "project_videos", label: "Project Videos & Photos", type: "file" },
//       { name: "linked_documents", label: "Linked Documents", type: "file" },
//       { name: "mortgage_gauge_plots", label: "Are there mortgage gauge plots?", type: "radio", options: ["Yes", "No"] },
//       { name: "development_progress", label: "How far has the development progressed?", type: "select", options: ["0-10%", "10-25%", "25-50%", "50-75%", "75-100%"] },
//       { name: "is_own_land", label: "Is this the company's own land?", type: "radio", options: ["Yes", "No"] },
//       { name: "is_own_venture", label: "Is this a company-owned venture?", type: "radio", options: ["Yes", "No"] },
//       { name: "bank_loan", label: "Will I get a bank loan?", type: "radio", options: ["Yes", "No"] },
//       { name: "associate_highest_commission", label: "Highest Commission (%)", type: "number" },
//       { name: "plp_margin", label: "PLP Commission (%)", type: "number" },
//     ]
//   },
//   independent_house: {
//     title: "Independent House Procurement Checklist",
//     fields: [
//       { name: "company_name", label: "Company/Builder Name", type: "text" },
//       { name: "project_location", label: "Location", type: "text" },
//       { name: "project_brochures", label: "Project Brochures", type: "file" },
//       { name: "project_videos", label: "Project Videos & Photos", type: "file" },
//       { name: "development_progress", label: "How far has the development progressed?", type: "select", options: ["0-10%", "10-25%", "25-50%", "50-75%", "75-100%"] },
//       { name: "bank_loan", label: "Will I get a bank loan?", type: "radio", options: ["Yes", "No"] },
//       { name: "hydra_rules", label: "Did you follow the Hydra rules when constructing?", type: "radio", options: ["Yes", "No"] },
//       { name: "entry_timing", label: "When can you enter the house?", type: "radio", options: ["WITHIN 2 MONTHS", "2 - 6 MONTHS", "1 - 2 YEARS", "2 - 3 YEARS","3+ YEARS"] },
//       { name: "oc", label: "Did the OC come?", type: "radio", options: ["Yes", "No"] },
//       { name: "link_documents", label: "Link Documents", type: "file" },
//       { name: "property_documents", label: "Property Documents", type: "file" },
//       { name: "aadhaar", label: "Builder/Owner Aadhaar", type: "file" },
//       { name: "pan", label: "Builder/Owner PAN", type: "file" },
//       { name: "associate_highest_commission", label: "What is the channel partner/agent commission?", type: "number" },
//       { name: "plp_margin", label: "Commission to PERFECT LAYOUT (%)", type: "number" },
//     ]
//   },
//   resale_house: {
//     title: "Resale Independent House Procurement Checklist",
//     fields: [
//       { name: "company_name", label: "Owner's Name", type: "text" },
//       { name: "project_location", label: "Location", type: "text" },
//       { name: "project_age", label: "Property Age", type: "number" },
//       { name: "project_videos", label: "Property Videos & Photos", type: "file" },
//       { name: "bank_loan", label: "Will I get a bank loan?", type: "radio", options: ["Yes", "No"] },
//       { name: "link_documents", label: "Link Documents", type: "file" },
//       { name: "legal_opinion", label: "Legal Opinion", type: "file" },
//       { name: "property_documents", label: "Property Documents", type: "file" },
//       { name: "aadhaar", label: "Owner Aadhaar", type: "file" },
//       { name: "pan", label: "Owner PAN", type: "file" },
//       { name: "photo", label: "Owner Photo", type: "file" },
//       { name: "hydra_rules", label: "Did you follow the Hydra rules when constructing?", type: "radio", options: ["Yes", "No"] },
//       { name: "associate_highest_commission", label: "What is the channel partner/agent commission?", type: "number" },
//       { name: "plp_margin", label: "Commission to PERFECT LAYOUT (%)", type: "number" },
//     ]
//   },
//   villa_apartment: {
//     title: "Villa / Standalone / Highrise / Semi-Gated Apartments Procurement Checklist",
//     fields: [
//       { name: "company_name", label: "Company/Builder Name", type: "text" },
//       { name: "project_type", label: "Project Type", type: "select", options: ["GATED VILLAS", "GATED APARTMENTS (HIGH RISE)", "STANDALONE APARTMENT", "SEMI GATED APARTMENTS"] },
//       { name: "project_name", label: "Project Name", type: "text" },
//       { name: "project_location", label: "Location", type: "text" },
//       { name: "rera_number", label: "RERA Number", type: "text" },
//       { name: "rera_certificate", label: "RERA Certificate", type: "file" },
//       { name: "project_brochures", label: "Project Brochures", type: "file" },
//       { name: "project_videos", label: "Project Videos & Photos", type: "file" },
//       { name: "entry_timing", label: "When can you enter the house?", type: "radio", options: ["WITHIN 2 MONTHS", "2 - 6 MONTHS", "1 - 2 YEARS", "2 - 3 YEARS","3+ YEARS"] },
//       { name: "development_progress", label: "Development Progress", type: "select", options: ["0-10%", "10-25%", "25-50%", "50-75%", "75-100%"] },
//       { name: "bank_loan", label: "Will I get a bank loan?", type: "radio", options: ["Yes", "No"] },
//       { name: "hydra_rules", label: "Followed Hydra Rules?", type: "radio", options: ["Yes", "No"] },
//       { name: "oc_arrived", label: "Has OC Arrived?", type: "radio", options: ["Yes", "No"] },
//       { name: "associate_highest_commission", label: "Channel Partner Commission (%)", type: "number" },
//       { name: "plp_margin", label: "Commission to PERFECT LAYOUT (%)", type: "number" },
//     ]
//   }
// };

// const StyledCard2 = styled(Card)(() => ({
//   maxWidth: 1200,
//   margin: "0 auto",
//   borderRadius: 16,
//   boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
//   background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
//   border: "1px solid rgba(255,255,255,0.2)",
// }));

// const UploadBox = styled(Box)(({ theme, isUploaded }) => ({
//   border: isUploaded ? "2px solid #4caf50" : "2px dashed #1976d2",
//   borderRadius: 12,
//   padding: theme.spacing(3),
//   textAlign: "center",
//   backgroundColor: isUploaded ? "#e8f5e9" : "#f8fafc",
//   cursor: "pointer",
//   transition: "all 0.3s ease",
//   "&:hover": {
//     backgroundColor: "#e3f2fd",
//     borderColor: "#1565c0",
//   },
// }));

// const PreviewImage = styled("img")(() => ({
//   width: "100%",
//   height: 180,
//   objectFit: "cover",
//   borderRadius: 8,
//   border: "1px solid #ddd",
//   marginTop: 12,
// }));
// // =============================
// // Validation Schema (dynamic)
// // =============================
// const getValidationSchema = (fields) => {
//   const shape = {};
//   fields.forEach((f) => {
//     if (f.required) {
//       if (f.type === "number") shape[f.name] = Yup.number().required(`${f.label} is required`);
//       else shape[f.name] = Yup.string().required(`${f.label} is required`);
//     }
//   });
//   return Yup.object().shape(shape);
// };

// // =============================
// // Styled Components
// // =============================
// const StyledCard = styled(Card)(({ theme }) => ({
//   maxWidth: 1200,
//   margin: "0 auto",
//   borderRadius: 16,
//   boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
//   background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
//   border: "1px solid rgba(255,255,255,0.2)",
// }));

// // =============================
// // Component
// // =============================
// const LayoutOnboardingRequest = () => {
//   const navigate = useNavigate();
//   const [selectedType, setSelectedType] = useState("farmland");
//   const config = FORM_CONFIG[selectedType];
//   const [previews, setPreviews] = useState({});

//   const initialValues = config.fields.reduce((acc, f) => ({ ...acc, [f.name]: "" }), {});

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues,
//     validationSchema: getValidationSchema(config.fields),
//     onSubmit: async (values, { setSubmitting, resetForm }) => {
//       try {
//         const res = await Post(`${apiURL}/api/v1/layouts/create_request`, {
//           type: selectedType,
//           ...values,
//         });
//         if (res?.data?.status) {
//           toast.success(res.data.message || "Request Submitted Successfully");
//           resetForm();
//           navigate("/dashboard/procurement");
//         } else toast.error(res?.data?.message || "Please Try Again");
//       } catch (err) {
//         console.error(err);
//         toast.error("Something went wrong");
//       } finally {
//         setSubmitting(false);
//       }
//     },
//   });

//   const { handleSubmit, getFieldProps, setFieldValue, errors, touched, isSubmitting } = formik;


//   const handleFileChange = (fieldName, file) => {
//     if (!file) return;
//     setFieldValue(fieldName, file);

//     const fileType = file.type;
//     if (fileType.startsWith("image/")) {
//       const url = URL.createObjectURL(file);
//       setPreviews((prev) => ({ ...prev, [fieldName]: url }));
//     } else {
//       setPreviews((prev) => ({ ...prev, [fieldName]: file.name }));
//     }
//   };


//  const FileUploadField = ({ field }) => {
//     const preview = previews[field.name];
//     const uploaded = Boolean(preview);

//     return (
//       <Box>
//         {/* Hidden input completely */}
//         <input
//           id={`file_${field.name}`}
//           type="file"
//           style={{ display: "none" }}
//           onChange={(e) => handleFileChange(field.name, e.target.files[0])}
//         />

//         <UploadBox
//           isUploaded={uploaded}
//           onClick={() => document.getElementById(`file_${field.name}`).click()}
//         >
//           {uploaded ? (
//             <>
//               <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 42 }} />
//               <Typography variant="h6" color="success.main">
//                 {field.label} Uploaded
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Click to upload a different file
//               </Typography>
//             </>
//           ) : (
//             <>
//               <CloudUploadIcon sx={{ fontSize: 42, color: "#1976d2" }} />
//               <Typography variant="h6" color="primary">
//                 {field.label}
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Click or drag file to upload
//               </Typography>
//             </>
//           )}
//         </UploadBox>

//         {preview && (
//           <>
//             {preview.startsWith("blob:") ? (
//               <PreviewImage src={preview} alt="preview" />
//             ) : (
//               <Stack direction="row" spacing={1} alignItems="center" mt={1}>
//                 <DownloadIcon fontSize="small" />
//                 <Link
//                   component="button"
//                   variant="body2"
//                   onClick={() => {
//                     const file = formik.values[field.name];
//                     if (file instanceof File) {
//                       const url = URL.createObjectURL(file);
//                       window.open(url, "_blank");
//                     }
//                   }}
//                 >
//                   {preview}
//                 </Link>
//               </Stack>
//             )}
//           </>
//         )}
//       </Box>
//     );
//   };


//   return (
//  <FormikProvider value={formik}>
//       <Form onSubmit={handleSubmit}>
//         <StyledCard>
//           <CardContent sx={{ p: 4 }}>
//             {/* Header */}
//             <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
//               <Box
//                 sx={{
//                   bgcolor: "#1976d2",
//                   borderRadius: "50%",
//                   width: 64,
//                   height: 64,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <BusinessIcon sx={{ color: "#fff", fontSize: 32 }} />
//               </Box>
//               <Box>
//                 <Typography variant="h4" fontWeight="bold" color="text.primary">
//                   Procurement Checklist
//                 </Typography>
//                 <Typography variant="h6" color="text.secondary">
//                   Fill details based on project type
//                 </Typography>
//               </Box>
//             </Stack>

//             <Divider sx={{ mb: 3 }} />

//             {/* Type Selector */}
//             <TextField
//               select
//               fullWidth
//               label="Select Project Type"
//               value={selectedType}
//               onChange={(e) => setSelectedType(e.target.value)}
//               sx={{ mb: 3 }}
//             >
//               {Object.keys(FORM_CONFIG).map((key) => (
//                 <MenuItem key={key} value={key}>
//                   {FORM_CONFIG[key].title}
//                 </MenuItem>
//               ))}
//             </TextField>

//             {/* Dynamic Fields */}
//             <Grid container spacing={3}>
//               {config.fields.map((field) => (
//                 <Grid item xs={12} sm={6} key={field.name}>
//                   {field.type === "text" || field.type === "number" ? (
//                     <TextField
//                       fullWidth
//                       label={field.label}
//                       type={field.type}
//                       {...getFieldProps(field.name)}
//                       error={Boolean(touched[field.name] && errors[field.name])}
//                       helperText={touched[field.name] && errors[field.name]}
//                     />
//                   ) : field.type === "select" ? (
//                     <TextField
//                       select
//                       fullWidth
//                       label={field.label}
//                       {...getFieldProps(field.name)}
//                       error={Boolean(touched[field.name] && errors[field.name])}
//                       helperText={touched[field.name] && errors[field.name]}
//                     >
//                       {field.options.map((opt) => (
//                         <MenuItem key={opt} value={opt}>
//                           {opt}
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                   ) : field.type === "radio" ? (
//                     <FormControl component="fieldset" fullWidth>
//                       <FormLabel>{field.label}</FormLabel>
//                       <RadioGroup row {...getFieldProps(field.name)}>
//                         {field.options.map((opt) => (
//                           <FormControlLabel key={opt} value={opt} control={<Radio />} label={opt} />
//                         ))}
//                       </RadioGroup>
//                     </FormControl>
//                   ) : field.type === "file" ? (
//                     <FileUploadField field={field} />
//                   ) : null}
//                 </Grid>
//               ))}
//             </Grid>
//           </CardContent>

//           <CardActions sx={{ p: 3, justifyContent: "flex-end" }}>
//             <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
//               Submit Request
//             </LoadingButton>
//           </CardActions>
//         </StyledCard>
//       </Form>
//     </FormikProvider>
//   );
// };

// export default LayoutOnboardingRequest;





import React, { useState, useEffect } from "react";
import { FormikProvider, useFormik, Form } from "formik";
import * as Yup from "yup";
import {
  CardContent,
  CardActions,
  TextField,
  Box,
  Stack,
  Grid,
  Typography,
  Divider,
  MenuItem,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Link,
  IconButton,
  Checkbox,
  Modal,
  Button,
  Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Post, apiURL } from "../../../utils/apiCalls";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BusinessIcon from "@mui/icons-material/Business";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";

// =============================
// Styled Components
// =============================
const UploadBox = styled(Box)(({ theme, isUploaded }) => ({
  border: isUploaded ? "2px solid #4caf50" : "2px dashed #1976d2",
  borderRadius: 12,
  padding: theme.spacing(3),
  textAlign: "center",
  cursor: "pointer",
  backgroundColor: isUploaded ? "#e8f5e9" : "#f8fafc",
  transition: "0.3s",
  "&:hover": {
    backgroundColor: isUploaded ? "#d0f0d1" : "#e3f2fd",
  },
}));

// const PreviewImage = styled("img")({
//   width: "100%",
//   maxWidth: 200,
//   height: "auto",
//   marginTop: 8,
//   borderRadius: 8,
//   border: "1px solid #ccc",
// });

// =============================
// Validation Schema (dynamic)
// =============================
const getValidationSchema = (fields) => {
  const shape = {};
  fields.forEach((f) => {
    if (f.required) {
      if (f.type === "number") {
        shape[f.name] = Yup.number().required(`${f.label} is required`);
      } else {
        shape[f.name] = Yup.string().required(`${f.label} is required`);
      }
    }
  });
  // Extra validation for procurement partners count (optional but if present, must be >= 1)
  shape.procurement_partners_count = Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    )
    .min(1, "At least 1 procurement partner is required")
    .typeError("Procurement partners count must be a number");

  // Accept terms & conditions must be checked
  shape.accept_terms = Yup.boolean()
    .oneOf([true], "You must accept the terms and conditions")
    .required("You must accept the terms and conditions");

  return Yup.object().shape(shape);
};

// =============================
// FILE UPLOAD FIELD (API Integrated)
// =============================
const FileUploadField = ({ field, formik, previews, setPreviews }) => {
  const [uploading, setUploading] = useState(false);
  const [uploadedUrl, setUploadedUrl] = useState(formik.values[field.name] || null);
  const uploaded = Boolean(uploadedUrl);

  const handleFileChange = async (file) => {
    if (!file) return;
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("document_type", field.name);

      console.log("FormData being sent:", {
        fileName: file.name,
        documentType: field.name,
        fileSize: file.size,
      });

      const response = await fetch(`${apiURL}/api/v1/layouts/upload_document`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        body: formData,
      });

      const result = await response.json();
      console.log("Upload Response:", result);

      if (result?.data?.s3_url) {
        toast.success(`${field.label} uploaded successfully`);
        const fileUrl = result.data.s3_url;
        setUploadedUrl(fileUrl);
        formik.setFieldValue(field.name, result?.data?.id);

        if (file.type.startsWith("image/")) {
          const localPreview = URL.createObjectURL(file);
          setPreviews((prev) => ({ ...prev, [field.name]: localPreview }));
        }
      } else {
        throw new Error(result?.message || "Upload failed");
      }
    } catch (err) {
      console.error("Upload Error:", err);
      toast.error("File upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box>
      <input
        id={`file_${field.name}`}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => handleFileChange(e.target.files[0])}
      />

      <UploadBox
        isUploaded={uploaded}
        onClick={() => document.getElementById(`file_${field.name}`).click()}
      >
        {uploading ? (
          <>
            <CloudUploadIcon sx={{ color: "#1565c0", fontSize: 40 }} />
            <Typography variant="body1" color="primary">
              Uploading {field.label}...
            </Typography>
          </>
        ) : uploaded ? (
          <>
            <CheckCircleIcon sx={{ color: "#4caf50", fontSize: 40 }} />
            <Typography variant="body1" color="success.main">
              {field.label} Uploaded Successfully
            </Typography>
            {console.log("Uploaded URL:", uploadedUrl)}
     
          </>

        ) : (
          <>
            <CloudUploadIcon sx={{ fontSize: 40, color: "#1976d2" }} />
            <Typography variant="body1" color="primary">
              {field.label}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Click to upload
            </Typography>
          </>
        )}
      </UploadBox>
      {uploadedUrl && (
       <Link
              href={uploadedUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ mt: 1, display: "block" }}
            >
              Open Uploaded File
            </Link>
          )}
    </Box>
  );
};

// =============================
// Dynamic Points Field (for project_highlights & amenities)
// =============================
const PointsField = ({ field, formik }) => {
  const { values, setFieldValue, touched, errors } = formik;
  const rawValue = values[field.name] || "";

  const [items, setItems] = useState(
    typeof rawValue === "string" && rawValue.trim()
      ? rawValue.split("\n").map((l) => l.trim())
      : [""]
  );

  // Keep local items in sync if form is reset or type changes
  useEffect(() => {
    const lines =
      typeof rawValue === "string" && rawValue.trim()
        ? rawValue.split("\n").map((l) => l.trim())
        : [""];
    setItems(lines);
  }, [rawValue, field.name]);

  const updateFormValue = (newItems) => {
    const filtered = newItems.map((i) => i.trim()).filter((i) => i.length > 0);
    setFieldValue(field.name, filtered.join("\n"));
  };

  const handleChangeItem = (index, value) => {
    const newItems = [...items];
    newItems[index] = value;
    setItems(newItems);
    updateFormValue(newItems);
  };

  const handleAdd = () => {
    setItems((prev) => [...prev, ""]);
  };

  const handleRemove = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    const next = newItems.length ? newItems : [""];
    setItems(next);
    updateFormValue(next);
  };

  const hasError = Boolean(touched[field.name] && errors[field.name]);
  const helperText = touched[field.name] && errors[field.name];

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        {field.label}
      </Typography>
      <Stack spacing={1}>
        {items.map((item, index) => (
          <Stack
            direction="row"
            spacing={1}
            key={`${field.name}-${index}`}
            alignItems="flex-start"
          >
            <TextField
              fullWidth
              size="small"
              label={`Point ${index + 1}`}
              value={item}
              onChange={(e) => handleChangeItem(index, e.target.value)}
              error={hasError && !item.trim()}
            />
            <IconButton
              size="small"
              color="error"
              onClick={() => handleRemove(index)}
              disabled={items.length === 1}
            >
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Stack>
        ))}
        <Box>
          <IconButton color="primary" size="small" onClick={handleAdd}>
            <AddCircleOutlineIcon fontSize="small" />
          </IconButton>
          <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
            Add another point
          </Typography>
        </Box>
        {hasError && (
          <Typography variant="caption" color="error">
            {helperText}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

// =============================
// Terms & Conditions Modal
// =============================
const TermsAndConditionsModal = ({ open, onClose, partners, adminPartners, currentUserName }) => {
  const getPartnerName = (partner, index) => {
    if (index === 0) {
      return currentUserName || "PP1 (Logged-in user)";
    }
    if (partner.admin_id) {
      const admin = adminPartners.find((a) => String(a.id) === String(partner.admin_id));
      if (admin) {
        return `${admin.first_name || ""} ${admin.last_name || ""}${
          admin.emp_id ? ` (${admin.emp_id})` : ""
        }`.trim();
      }
    }
    return `PP${index + 1}`;
  };

  const currentDate = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  return (
    <Modal open={open} onClose={onClose}>
      <Paper
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 900,
          maxHeight: '90vh',
          overflow: 'auto',
          p: 4,
          outline: 'none',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h5" fontWeight="bold">
            PROCUREMENT PARTNER — TERMS & CONDITIONS
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 3 }} />
        
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            (To be executed on ₹50 Bond Paper)
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            This MOU is entered into between Parfect Layout Pvt Ltd (hereinafter "Company") and the following Procurement Partners (hereinafter "Procurement Partner" or "PP") on this {currentDate} at [place].
          </Typography>
          
          {/* Dynamic Partner List */}
          <Box sx={{ mb: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
              Procurement Partners:
            </Typography>
            {partners.map((partner, index) => (
              <Typography key={index} variant="body2" sx={{ mb: 0.5 }}>
                • {getPartnerName(partner, index)} - Commission: {partner.commission_percentage || 0}%
                {partner.is_primary && " (Primary)"}
              </Typography>
            ))}
            <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
              Total Commission: {partners.reduce((sum, p) => sum + (parseFloat(p.commission_percentage) || 0), 0)}%
            </Typography>
          </Box>
        </Box>

        <Box sx={{ maxHeight: '60vh', overflow: 'auto', pr: 1 }}>
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>1. Definitions</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            <strong>Procurement Partner (PP):</strong> person/entity introducing new ventures/projects to the Company and negotiating commission/fee arrangements with venture/project owners.<br/><br/>
            <strong>Venture / Project Owner:</strong> the third-party owner/developer who engages Company's services.<br/><br/>
            <strong>Company Margin:</strong> amount/fee retained by Company from the total fee/commission paid by the venture owner after statutory taxes and direct expense recoveries.<br/><br/>
            <strong>Protected Lead Period:</strong> period during which a lead introduced by PP will still be eligible for commission (default: 12 months from introduction; can be changed by written agreement).
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>2. Appointment & Scope</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            The Company appoints PP on a non-exclusive basis (unless a written exclusive territory/sector is attached) to source and onboard new ventures/projects and to negotiate commission/fee structures in favour of the Company.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>3. Core Duties & Responsibilities</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body2">Maintain good relationships with marketing associates, venture owners and the Company. Any miscommunication or violation of Company ethics/rules may lead to termination of PP code.</Typography></li>
            <li><Typography variant="body2">Be available and responsive to both Company staff and marketing personnel during onboarding and closure processes.</Typography></li>
            <li><Typography variant="body2">Identify legal, regulatory or compliance issues in ventures and report them to the Company prior to onboarding. Obtain legal opinion where required and ensure ventures comply with government norms.</Typography></li>
            <li><Typography variant="body2">Identify and report any unethical or fraudulent practices in ventures/projects.</Typography></li>
            <li><Typography variant="body2">Handle all money matters transparently — do not accept or disburse Company/venture funds without written authorization.</Typography></li>
            <li><Typography variant="body2">Oversee process from initial negotiation → sale/booking → registration → handover of documents to Company, and ensure timely submission of all required paperwork.</Typography></li>
            <li><Typography variant="body2">Negotiate and finalize commission/fee terms with venture/project owners on behalf of or in favour of the Company and document agreements in writing.</Typography></li>
            <li><Typography variant="body2">Do not provide guarantees or assurances of sales/closures on behalf of the Company; Parfect Layout Pvt Ltd does not guarantee sales or sales commitments.</Typography></li>
            <li><Typography variant="body2">Disclose any conflicts of interest or prior relationships with venture owners before negotiations.</Typography></li>
            <li><Typography variant="body2">Cooperate with Company audits and verification processes when requested.</Typography></li>
          </Box>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>4. Documents & Onboarding</Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>PP must submit the following at the time of joining:</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body2">Aadhaar Card (copy)</Typography></li>
            <li><Typography variant="body2">PAN Card (copy)</Typography></li>
            <li><Typography variant="body2">Passport-size photograph</Typography></li>
            <li><Typography variant="body2">Signed MOU on ₹50 bond paper (this document)</Typography></li>
            <li><Typography variant="body2">Any additional documents required for KYC/background verification</Typography></li>
          </Box>
          <Typography variant="body2" sx={{ mb: 2 }}>Company reserves right to conduct background checks and decline onboarding.</Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>5. Remuneration & Commission</Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>Standard:</strong> PP will receive 10% of the Company Margin for each successful venture/project procured and executed through the Company, unless another rate is agreed in writing.<br/><br/>
            <strong>Payment trigger:</strong> Payment to PP will be made after Company has received its margin/fee from the venture owner and all transaction conditions (sale/registration) are satisfied.<br/><br/>
            <strong>Taxes & Invoices:</strong> All payments are subject to applicable tax deductions and statutory compliances. PP must submit a valid invoice and any required tax documentation for every payment. Any GST liability or statutory dues arising on PP's invoices are PP's responsibility.<br/><br/>
            <strong>Sample calculation (illustrative):</strong><br/>
            Fee received from venture owner = ₹1,00,000<br/>
            Direct expenses / statutory taxes / agreed deductions = ₹20,000<br/>
            Company Margin = ₹80,000<br/>
            PP Share (10%) = ₹8,000<br/><br/>
            <strong>Clawback:</strong> If the venture owner cancels or refunds within [12] months due to fraud/issue, Company reserves right to recover proportionate amounts paid to PP (except in cases where PP can prove no fault).
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>6. Lead Protection and Attribution</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            A lead introduced by PP will be considered an introduced lead if the Company receives written evidence (email, signed LOI, minutes) from PP.<br/><br/>
            Company will honour commission to PP for deals closed with that lead within the Protected Lead Period (45 days) from the date of introduction. After termination, Company will continue to pay commission for deals closed within the Protected Lead Period only if PP introduced the lead in writing prior to termination.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>7. Expenses</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            PP will generally bear their own travel/meeting expenses unless prior written approval for reimbursement is obtained from Company. Reimbursements will be paid only against original bills and as per Company policy.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>8. Exclusivity & Territories (optional)</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            The engagement is non-exclusive unless otherwise agreed. If an exclusive territory or sector is to be granted, it must be specified in Schedule A (attached).
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>9. Confidentiality & Data Protection</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            PP will not disclose any confidential information of the Company, venture owners or customers to third parties. Confidential information includes pricing, commission structures, client lists, contract terms, project documents, and financial data.<br/><br/>
            This obligation survives termination for a period of 3 years (or longer if required by law).
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>10. Non-Compete & Non-Solicitation (reasonable & time-bound)</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            During the term and for 12 months after termination, PP shall not directly engage with or solicit the Company's clients/associates for competing services or poach Company employees/associates. (Optional: tighten or reduce period as per Company policy.)
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>11. Representations & Warranties</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            PP represents and warrants that they have the legal capacity to enter into this MOU, will act professionally, and will not violate any law while performing duties.<br/><br/>
            PP must disclose any criminal proceedings, insolvency or material litigation against them at onboarding.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>12. Term & Termination</Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>Term:</strong> This MOU remains in force until terminated by either party in writing.<br/><br/>
            <strong>Termination for cause:</strong> Company may terminate PP immediately for fraud, misuse of funds, ethical violations, non-performance, material misrepresentation or illegal activity.<br/><br/>
            <strong>Termination for convenience:</strong> Either party may terminate on 30 days' written notice (or mutually agreed period). (You can shorten/lengthen this in Schedule B.)<br/><br/>
            On termination PP must hand over all documents, leads, files and return Company property within 7 days.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>13. Audit, Records & Cooperation</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            PP must maintain clear records of all introductions, communications and agreements. Company may audit these records periodically. PP shall cooperate with internal/external audits.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>14. Indemnity & Liability</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            PP will indemnify and hold Company harmless from losses arising from PP's negligence, breach, misrepresentation or illegal acts.<br/><br/>
            Company's liability to PP shall be limited to amounts actually paid/receivable by Company for the related project (subject to law). Neither party will be liable for indirect/consequential loss except where required by law.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>15. Insurance</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            PP is advised to maintain professional liability or relevant insurance cover at their cost where applicable.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>16. Dispute Resolution & Governing Law</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Any dispute arising from this MOU will be resolved by mutual discussion, failing which by arbitration in [City], India under the Indian Arbitration & Conciliation Act. The decision of arbitrator(s) will be final.<br/><br/>
            Governing law: Laws of India. Jurisdiction: courts at [City] for enforcement matters only.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>17. Amendment & Severability</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Any amendment must be in writing and signed by both parties. If any clause is declared void, remaining clauses remain in effect.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>18. Entire Agreement</Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            This document (plus any schedules) constitutes the entire agreement between the parties regarding procurement partner activities.
          </Typography>

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 1, mt: 3 }}>DECLARATION</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body2">I have read and accepted all terms in the Procurement Partner MOU with Parfect Layout Pvt Ltd.</Typography></li>
            <li><Typography variant="body2">All information and documents I submitted are true and correct.</Typography></li>
            <li><Typography variant="body2">I will follow all company rules and work professionally without misusing the company name or documents.</Typography></li>
            <li><Typography variant="body2">I will not collect any money from customers, associates, or venture owners on behalf of the company.</Typography></li>
            <li><Typography variant="body2">My role is only to bring ventures and support meetings, registrations, and coordination as required.</Typography></li>
            <li><Typography variant="body2">I will keep all company data, documents, and project details strictly confidential.</Typography></li>
            <li><Typography variant="body2">I will not share, misuse, or transfer company leads, data, or contacts to anyone.</Typography></li>
            <li><Typography variant="body2">I understand commission will be provided only after the company receives its margin as per the MOU.</Typography></li>
            <li><Typography variant="body2">I agree that any violation of these conditions may lead to cancellation of my PP Code.</Typography></li>
            <li><Typography variant="body2">I understand that I am fully responsible for my actions, and if any legal issue arises due to my mistake, I will bear all legal consequences, penalties, and legal expenses. The company will not be responsible in any manner.</Typography></li>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>Signatures</Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Procurement Partner:</strong>
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Name: <strong>{currentUserName || "PP1 (Logged-in user)"}</strong>
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Date: {currentDate}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <Button variant="contained" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

// =============================
// Procurement Partners Section
// =============================
const ProcurementPartnersSection = ({ formik, adminPartners, currentUserName, currentUserId }) => {
  const { values, setFieldValue, touched, errors } = formik;
  const [tcModalOpen, setTcModalOpen] = useState(false);
  const countRaw = values.procurement_partners_count;
  const count = Math.max(
    1,
    parseInt(countRaw || "1", 10) > 0 ? parseInt(countRaw, 10) : 1
  );

  // partners are stored as JSON string in values.procurement_partners
  let parsed = [];
  try {
    parsed = values.procurement_partners
      ? JSON.parse(values.procurement_partners)
      : [];
  } catch (e) {
    parsed = [];
  }

  // Ensure array has at least `count` entries
  let partners = [...parsed];
  while (partners.length < count) {
    partners.push({
      admin_id: partners.length === 0 && currentUserId ? String(currentUserId) : "", // PP1 gets current user's ID
      commission_percentage: partners.length === 0 && count === 1 ? "100" : "", // Default PP1 to 100% when count is 1
      is_primary: partners.length === 0, // first one is primary
    });
  }
  if (partners.length > count) {
    partners.length = count;
  }

  // Ensure PP1 is marked as primary and has current user's ID
  if (partners.length > 0) {
    partners[0] = { 
      ...partners[0], 
      is_primary: true,
      admin_id: currentUserId ? String(currentUserId) : partners[0].admin_id || "",
    };
  }

  // Use useEffect to ensure default PP1 commission is 100% and admin_id is set when count is 1
  useEffect(() => {
    if (count === 1 && currentUserId) {
      let currentParsed = [];
      try {
        currentParsed = values.procurement_partners
          ? JSON.parse(values.procurement_partners)
          : [];
      } catch (e) {
        currentParsed = [];
      }

      if (currentParsed.length === 0) {
        // Initialize with PP1 at 100% and current user's ID
        const defaultPartner = {
          admin_id: String(currentUserId),
          commission_percentage: "100",
          is_primary: true,
        };
        setFieldValue("procurement_partners", JSON.stringify([defaultPartner]));
      } else if (currentParsed.length > 0) {
        const needsUpdate = 
          currentParsed[0]?.admin_id !== String(currentUserId) ||
          (currentParsed[0]?.commission_percentage === "" || 
           currentParsed[0]?.commission_percentage === null || 
           currentParsed[0]?.commission_percentage === undefined || 
           currentParsed[0]?.commission_percentage === "0");
        
        if (needsUpdate) {
          const next = [...currentParsed];
          next[0] = { 
            ...next[0], 
            admin_id: String(currentUserId),
            commission_percentage: next[0].commission_percentage || "100", 
            is_primary: true 
          };
          setFieldValue("procurement_partners", JSON.stringify(next));
        }
      }
    }
  }, [count, currentUserId, values.procurement_partners, setFieldValue]);

  const updatePartners = (next) => {
    setFieldValue("procurement_partners", JSON.stringify(next));
    setFieldValue("procurement_partners_count", next.length);
  };

  const handleChange = (index, field, value) => {
    const next = partners.map((p, i) =>
      i === index ? { ...p, [field]: value } : p
    );
    updatePartners(next);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Stack spacing={2}>
        {/* PP1 – primary (logged-in user) */}
        <Box
          sx={{
            p: 2,
            borderRadius: 1,
            border: "1px solid #e0e0e0",
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="subtitle2" gutterBottom>
            PP1 (Primary Procurement Partner – {currentUserName || "Logged-in user"})
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="PP1 Commission Percentage (%)"
                type="number"
                value={partners[0]?.commission_percentage || ""}
                onChange={(e) =>
                  handleChange(0, "commission_percentage", e.target.value)
                }
                  InputProps={{
                    readOnly: count === 1, // when only 1 partner, keep at 100%
                  }}
                  helperText={
                    count === 1
                      ? "With 1 partner, commission is fixed at 100%."
                      : ""
                  }
              />
            </Grid>
          </Grid>
        </Box>

        {/* Additional partners PP2..PPn */}
        {partners.slice(1).map((partner, idx) => {
          const index = idx + 1; // actual partner index (PP2 = 1, etc.)
          return (
            <Box
              key={`pp-${index}`}
              sx={{
                p: 2,
                borderRadius: 1,
                border: "1px solid #e0e0e0",
              }}
            >
              <Typography variant="subtitle2" gutterBottom>
                PP{index + 0}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    select
                    fullWidth
                    label={`PP${index} Procurement Partner (Admin, role 3)`}
                    value={partner.admin_id || ""}
                    onChange={(e) =>
                      handleChange(index, "admin_id", e.target.value)
                    }
                  >
                    {adminPartners.map((admin) => (
                      <MenuItem key={admin.id} value={admin.id}>
                        {admin.first_name} {admin.last_name}{" "}
                        {admin.emp_id ? `(${admin.emp_id})` : ""}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label={`PP${index} Commission Percentage (%)`}
                    type="number"
                    value={partner.commission_percentage || ""}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "commission_percentage",
                        e.target.value
                      )
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          );
        })}
        {/* Summary & Terms and Conditions */}
        <Box
          sx={{
            p: 2,
            borderRadius: 1,
            border: "1px solid #e0e0e0",
            backgroundColor: "#fff",
          }}
        >
          <Typography variant="subtitle2" gutterBottom>
            Partners & Commission Summary
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 1 }}>
            {partners.map((p, idx) => {
              const isPrimary = idx === 0;
              let name = isPrimary
                ? currentUserName || "PP1 (Logged-in user)"
                : `PP${idx + 1}`;

              if (!isPrimary && p.admin_id) {
                const admin = adminPartners.find(
                  (a) => String(a.id) === String(p.admin_id)
                );
                if (admin) {
                  name = `${admin.first_name || ""} ${admin.last_name || ""}${
                    admin.emp_id ? ` (${admin.emp_id})` : ""
                  }`.trim();
                }
              }

              return (
                <li key={`summary-pp-${idx}`}>
                  {name} – {p.commission_percentage || 0}%
                </li>
              );
            })}
          </Box>
          <Typography variant="body2" sx={{ mb: 2, fontWeight: "bold" }}>
            Total commission:{" "}
            {partners.reduce(
              (sum, p) => sum + (parseFloat(p.commission_percentage) || 0),
              0
            )}
            %
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="subtitle2" gutterBottom sx={{ mb: 2 }}>
            Terms & Conditions
          </Typography>
          
          <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
            Please review all procurement partner names and their commission
            percentages above along with the detailed terms and conditions for
            this procurement partner agreement.
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Button
              variant="outlined"
              onClick={() => setTcModalOpen(true)}
              fullWidth
              sx={{ mb: 2 }}
            >
              View Full Terms & Conditions
            </Button>
          </Box>

          <Box sx={{ mt: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.accept_terms || false}
                  onChange={(e) =>
                    setFieldValue("accept_terms", e.target.checked)
                  }
                />
              }
              label={
                <Typography variant="body2">
                  I have read and accept the above terms and conditions.
                </Typography>
              }
            />
            {touched.accept_terms && errors.accept_terms && (
              <Typography variant="caption" color="error" display="block" sx={{ mt: 1, ml: 4 }}>
                {errors.accept_terms}
              </Typography>
            )}
          </Box>
        </Box>
      </Stack>

      {/* Terms & Conditions Modal */}
      <TermsAndConditionsModal
        open={tcModalOpen}
        onClose={() => setTcModalOpen(false)}
        partners={partners}
        adminPartners={adminPartners}
        currentUserName={currentUserName}
      />
    </Box>
  );
};

// =============================
// MAIN COMPONENT
// =============================
const LayoutOnboardingRequest = () => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("farmland");
  const [previews, setPreviews] = useState({});
  const [adminPartners, setAdminPartners] = useState([]);
  const [currentUserName, setCurrentUserName] = useState("");
  const [currentUserId, setCurrentUserId] = useState(null);

  // Load admin users with role 3 for procurement partner dropdown
  useEffect(() => {
    const loadAdmins = async () => {
      try {
        const response = await fetch(`${apiURL}/api/v1/procurement-admin-users`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });
        const result = await response.json();
        if (result?.status && Array.isArray(result.data)) {
          setAdminPartners(result.data);
        } else {
          console.warn("Failed to load admin partners:", result?.message);
        }
      } catch (err) {
        console.error("Error loading admin partners:", err);
      }
    };

    const loadCurrentUser = async () => {
      try {
        const response = await fetch(`${apiURL}/api/v1/users/admindetails`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });
        const result = await response.json();
        if (result?.status && result.data) {
          const raw = Array.isArray(result.data) ? result.data[0] : result.data;
          if (raw) {
            const fullName = `${raw.first_name || ""} ${raw.last_name || ""}`.trim();
            setCurrentUserName(fullName || raw.email || "");
            setCurrentUserId(raw.id || null);
          }
        }
      } catch (err) {
        console.error("Error loading current admin details:", err);
      }
    };

    loadAdmins();
    loadCurrentUser();
  }, []);

const FORM_CONFIG = {
  farmland: {
    title: "Farmland Plots",
    fields: [
      { name: "company_name", label: "Company Name", type: "text", required: true },
      { name: "project_name", label: "Project Name", type: "text", required: true },
      { name: "project_location", label: "Project Location", type: "text", required: true },
      { name: "highways", label: "On which highway is this project located?", type: "text" },
      { name: "google_map_link", label: "Google map link", type: "text" },

      // Pricing & charges
      { name: "price_per_sq_yard", label: "Price per Sq Yard", type: "number" },
      { name: "corner_charges_ne", label: "Corner Charges (North-East)", type: "number" },
      { name: "corner_charges_nw", label: "Corner Charges (North-West)", type: "number" },
      { name: "facing_charges_east", label: "Facing Charges (East)", type: "number" },
      { name: "facing_charges_north", label: "Facing Charges (North)", type: "number" },
      { name: "facing_charges_west", label: "Facing Charges (West)", type: "number" },
      { name: "project_brochures", label: "Project Brochures", type: "file" },
      { name: "project_videos", label: "Project Videos & Photos", type: "file" },
      { name: "linked_documents", label: "Linked Documents", type: "file" },
      { name: "development_progress", label: "How far has the development progressed?", type: "select", options: ["0-10%", "10-25%", "25-50%", "50-75%", "75-100%"] },
      { name: "is_own_land", label: "Is this the company's own land?", type: "radio", options: ["Yes", "No"] },
      { name: "is_own_venture", label: "Is this a company-owned venture?", type: "radio", options: ["Yes", "No"] },
      { name: "nala_conversion", label: "Will you do NALA conversion?", type: "radio", options: ["Yes", "No"] },
      {
        name: "registrations",
        label: "How many people will be involved in this land registration?",
        type: "number",
      },
      { name: "bank_loan", label: "Will I get a bank loan?", type: "radio", options: ["Yes", "No"] },
      { name: "associate_highest_commission", label: "What is the highest commission in the company?", type: "number" },
      { name: "plp_margin", label: "How much commission is given to PERFECT LAYOUT PVT LTD?", type: "number" },
      // Descriptive fields
      {
        name: "project_highlights",
        label: "Project Highlights (one point per line)",
        type: "textarea",
        required: true,
      },
      
      {
        name: "amenities",
        label: "Amenities (one point per line)",
        type: "textarea",
        required: true,
      },
    ]
  },
  open_plots: {
    title: "Open Plots Project",
    fields: [
      { name: "company_name", label: "Company Name", type: "text" },
      { name: "project_name", label: "Project Name", type: "text" },
      { name: "project_location", label: "Project Location", type: "text" },
      // Open plots project types should not allow Farm Land here
      { name: "project_type", label: "Project Type", type: "select", options: ["DTCP", "HMDA"] },
      { name: "highways", label: "On which highway is this project located?", type: "text" },
      { name: "google_map_link", label: "Google map link", type: "text" },

      // Pricing & charges
      { name: "price_per_sq_yard", label: "Price per Sq Yard", type: "number" },
      { name: "corner_charges_ne", label: "Corner Charges (North-East)", type: "number" },
      { name: "corner_charges_nw", label: "Corner Charges (North-West)", type: "number" },
      { name: "facing_charges_east", label: "Facing Charges (East)", type: "number" },
      { name: "facing_charges_north", label: "Facing Charges (North)", type: "number" },
      { name: "facing_charges_west", label: "Facing Charges (West)", type: "number" },
      { name: "rera_number", label: "RERA Number", type: "text" },
      { name: "rera_certificate", label: "RERA Certificate", type: "file" },
      { name: "lp_number", label: "LP Number", type: "text" },
      { name: "project_brochures", label: "Project Brochures", type: "file" },
      { name: "project_videos", label: "Project Videos & Photos", type: "file" },
      { name: "linked_documents", label: "Linked Documents", type: "file" },
      {
        name: "mortgage_gauge_plots",
        label: "Are there any mortgage plots?",
        type: "radio",
        options: ["Yes", "No"],
      },
      { name: "development_progress", label: "How far has the development progressed?", type: "select", options: ["0-10%", "10-25%", "25-50%", "50-75%", "75-100%"] },
      { name: "is_own_land", label: "Is this the company's own land?", type: "radio", options: ["Yes", "No"] },
      { name: "is_own_venture", label: "Is this a company-owned venture?", type: "radio", options: ["Yes", "No"] },
      { name: "bank_loan", label: "Will I get a bank loan?", type: "radio", options: ["Yes", "No"] },
      { name: "associate_highest_commission", label: "Highest Commission (%)", type: "number" },
      { name: "plp_margin", label: "PLP Commission (%)", type: "number" },
      { name: "google_map_link", label: "Google Map Link", type: "text" },
      {
        name: "project_highlights",
        label: "Project Highlights (one point per line)",
        type: "textarea",
        required: true,
      },
      {
        name: "amenities",
        label: "Amenities (one point per line)",
        type: "textarea",
        required: true,
      },
    ]
  },
  independent_house: {
    title: "Independent House",
    fields: [
      { name: "company_name", label: "Company/Builder Name", type: "text" },
      { name: "project_location", label: "Location", type: "text" },
      { name: "google_map_link", label: "Google map link", type: "text" },
      // Pricing
      { name: "price_per_sft", label: "Price per Sft", type: "number" },
      { name: "project_brochures", label: "Project Brochures", type: "file" },
      { name: "project_videos", label: "Project Videos & Photos", type: "file" },
      { name: "development_progress", label: "How far has the development progressed?", type: "select", options: ["0-10%", "10-25%", "25-50%", "50-75%", "75-100%"] },
      { name: "bank_loan", label: "Will I get a bank loan?", type: "radio", options: ["Yes", "No"] },
      { name: "hydra_rules", label: "Did you follow the Hydra rules when constructing?", type: "radio", options: ["Yes", "No"] },
      { name: "entry_timing", label: "When can you enter the house?", type: "radio", options: ["WITHIN 2 MONTHS", "2 - 6 MONTHS", "1 - 2 YEARS", "2 - 3 YEARS","3+ YEARS"] },
      { name: "oc", label: "Did the OC come?", type: "radio", options: ["Yes", "No"] },
      { name: "link_documents", label: "Link Documents", type: "file" },
      { name: "property_documents", label: "Property Documents", type: "file" },
      { name: "aadhaar", label: "Builder/Owner Aadhaar", type: "file" },
      { name: "pan", label: "Builder/Owner PAN", type: "file" },
      { name: "associate_highest_commission", label: "What is the channel partner/agent commission?", type: "number" },
      { name: "plp_margin", label: "Commission to PERFECT LAYOUT (%)", type: "number" },
      { name: "google_map_link", label: "Google Map Link", type: "text" },
      {
        name: "project_highlights",
        label: "Project Highlights (one point per line)",
        type: "textarea",
        required: true,
      },
      {
        name: "amenities",
        label: "Amenities (one point per line)",
        type: "textarea",
        required: true,
      },
    ]
  },
  resale_house: {
    title: "Resale Independent House",
    fields: [
      { name: "company_name", label: "Owner's Name", type: "text" },
      { name: "project_location", label: "Location", type: "text" },
      { name: "project_age", label: "Property Age", type: "number" },
      { name: "price_per_sft", label: "Price per Sft", type: "number" },
      { name: "google_map_link", label: "Google map link", type: "text" },
      { name: "project_videos", label: "Property Videos & Photos", type: "file" },
      { name: "bank_loan", label: "Will I get a bank loan?", type: "radio", options: ["Yes", "No"] },
      { name: "link_documents", label: "Link Documents", type: "file" },
      { name: "legal_opinion", label: "Legal Opinion", type: "file" },
      { name: "property_documents", label: "Property Documents", type: "file" },
      { name: "aadhaar", label: "Owner Aadhaar", type: "file" },
      { name: "pan", label: "Owner PAN", type: "file" },
      { name: "photo", label: "Owner Photo", type: "file" },
      { name: "hydra_rules", label: "Did you follow the Hydra rules when constructing?", type: "radio", options: ["Yes", "No"] },
      { name: "associate_highest_commission", label: "What is the channel partner/agent commission?", type: "number" },
      { name: "plp_margin", label: "Commission to PERFECT LAYOUT (%)", type: "number" },
      { name: "google_map_link", label: "Google Map Link", type: "text" },
      {
        name: "project_highlights",
        label: "Project Highlights (one point per line)",
        type: "textarea",
        required: true,
      },
      {
        name: "amenities",
        label: "Amenities (one point per line)",
        type: "textarea",
        required: true,
      },
    ]
  },
  villa_apartment: {
    title: "Villa / Standalone / Highrise / Semi-Gated Apartments",
    fields: [
      { name: "company_name", label: "Company/Builder Name", type: "text" },
      { name: "project_type", label: "Project Type", type: "select", options: ["GATED VILLAS", "GATED APARTMENTS (HIGH RISE)", "STANDALONE APARTMENT", "SEMI GATED APARTMENTS"] },
      { name: "project_name", label: "Project Name", type: "text" },
      { name: "project_location", label: "Location", type: "text" },
      { name: "price_per_sft", label: "Price per Sft", type: "number" },
      { name: "google_map_link", label: "Google map link", type: "text" },
      { name: "rera_number", label: "RERA Number", type: "text" },
      { name: "rera_certificate", label: "RERA Certificate", type: "file" },
      { name: "project_brochures", label: "Project Brochures", type: "file" },
      { name: "project_videos", label: "Project Videos & Photos", type: "file" },
      { name: "entry_timing", label: "When can you enter the house?", type: "radio", options: ["WITHIN 2 MONTHS", "2 - 6 MONTHS", "1 - 2 YEARS", "2 - 3 YEARS","3+ YEARS"] },
      { name: "development_progress", label: "Development Progress", type: "select", options: ["0-10%", "10-25%", "25-50%", "50-75%", "75-100%"] },
      { name: "bank_loan", label: "Will I get a bank loan?", type: "radio", options: ["Yes", "No"] },
      { name: "hydra_rules", label: "Followed Hydra Rules?", type: "radio", options: ["Yes", "No"] },
      { name: "oc_arrived", label: "Has OC Arrived?", type: "radio", options: ["Yes", "No"] },
      { name: "associate_highest_commission", label: "Channel Partner Commission (%)", type: "number" },
      { name: "plp_margin", label: "Commission to PERFECT LAYOUT (%)", type: "number" },
      { name: "google_map_link", label: "Google Map Link", type: "text" },
      {
        name: "project_highlights",
        label: "Project Highlights (one point per line)",
        type: "textarea",
        required: true,
      },
      {
        name: "amenities",
        label: "Amenities (one point per line)",
        type: "textarea",
        required: true,
      },
    ]
  }
};

  const config = FORM_CONFIG[selectedType];
  const baseInitialValues = config.fields.reduce(
    (acc, f) => ({ ...acc, [f.name]: "" }),
    {}
  );
  // Initialize PP1 with 100% commission as default
  const defaultPartners = JSON.stringify([
    {
      admin_id: "",
      commission_percentage: "100",
      is_primary: true,
    },
  ]);
  const initialValues = {
    ...baseInitialValues,
    procurement_partners_count: 1,
    procurement_partners: defaultPartners,
    accept_terms: false,
    bond_document: "",
    mou_document: "",
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: getValidationSchema(config.fields),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const res = await Post(`${apiURL}/api/v1/layouts/create_request`, {
          layout_type: FORM_CONFIG[selectedType].title,
          layout_type_key: selectedType,
          ...values,
        });
        if (res?.data?.status) {
          toast.success(res.data.message || "Request Submitted Successfully");
          resetForm();
          navigate("/dashboard/procurement");
        } else {
          toast.error(res?.data?.message || "Form submission was not accepted. Please check the highlighted fields.");
        }
      } catch (err) {
        console.error(err);
        const message =
          err?.response?.data?.message ||
          err?.message ||
          "Form submission was not accepted. Please check your details and try again.";
        toast.error(message);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const { handleSubmit, getFieldProps, errors, touched, isSubmitting } = formik;

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={handleSubmit}>
        <CardContent sx={{ p: 4 }}>
          {/* Header */}
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
            <Box
              sx={{
                bgcolor: "#1976d2",
                borderRadius: "50%",
                width: 64,
                height: 64,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <BusinessIcon sx={{ color: "#fff", fontSize: 32 }} />
            </Box>
            <Box>
              <Typography variant="h4" fontWeight="bold" color="text.primary">
                Procurement Checklist
              </Typography>
              <Typography variant="h6" color="text.secondary">
                Fill details based on project type
              </Typography>
            </Box>
          </Stack>

          <Divider sx={{ mb: 3 }} />

          {/* Type Selector */}
          <TextField
            select
            fullWidth
            label="Select Project Type"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            sx={{ mb: 3 }}
          >
            {Object.keys(FORM_CONFIG)
              // If current selection is Open Plots, hide Farmland from the type selector
              .filter((key) => !(selectedType === 'open_plots' && key === 'farmland'))
              .map((key) => (
              <MenuItem key={key} value={key}>
                {FORM_CONFIG[key].title}
              </MenuItem>
            ))}
          </TextField>

          {/* Dynamic Fields */}
          <Grid container spacing={3}>
            {config.fields.map((field) => (
              <Grid item xs={12} sm={6} key={field.name}>
                {field.type === "text" || field.type === "number" ? (
                  <TextField
                    fullWidth
                    label={field.label}
                    type={field.type}
                    {...getFieldProps(field.name)}
                    error={Boolean(touched[field.name] && errors[field.name])}
                    helperText={touched[field.name] && errors[field.name]}
                  />
                ) : field.type === "textarea" ? (
                  <PointsField field={field} formik={formik} />
                ) : field.type === "select" ? (
                  <TextField
                    select
                    fullWidth
                    label={field.label}
                    {...getFieldProps(field.name)}
                    error={Boolean(touched[field.name] && errors[field.name])}
                    helperText={touched[field.name] && errors[field.name]}
                  >
                    {field.options.map((opt) => (
                      <MenuItem key={opt} value={opt}>
                        {opt}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.type === "radio" ? (
                  <FormControl component="fieldset" fullWidth>
                    <FormLabel>{field.label}</FormLabel>
                    <RadioGroup row {...getFieldProps(field.name)}>
                      {field.options.map((opt) => (
                        <FormControlLabel
                          key={opt}
                          value={opt}
                          control={<Radio />}
                          label={opt}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                ) : field.type === "file" ? (
                  <FileUploadField
                    field={field}
                    formik={formik}
                    previews={previews}
                    setPreviews={setPreviews}
                  />
                ) : null}
              </Grid>
            ))}
          </Grid>

          {/* Procurement Partner Agreement */}
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" gutterBottom>
              Procurement Partner Agreement
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              PP1 is the logged-in procurement partner (primary). Add additional partners and their commission percentages below.
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  type="number"
                  label="How many procurement partners are involved?"
                  {...formik.getFieldProps("procurement_partners_count")}
                  error={Boolean(
                    formik.touched.procurement_partners_count &&
                      formik.errors.procurement_partners_count
                  )}
                  helperText={
                    formik.touched.procurement_partners_count &&
                    formik.errors.procurement_partners_count
                  }
                  inputProps={{ min: 1 }}
                />
              </Grid>
            </Grid>

            <ProcurementPartnersSection
              formik={formik}
              adminPartners={adminPartners}
              currentUserName={currentUserName}
              currentUserId={currentUserId}
            />
          </Box>

          {/* Agreements & Documents at very bottom of the form */}
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" gutterBottom>
              Agreements & Documents
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FileUploadField
                  field={{
                    name: "bond_document",
                    label: "Upload ₹20 Written Bond",
                  }}
                  formik={formik}
                  previews={previews}
                  setPreviews={setPreviews}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FileUploadField
                  field={{
                    name: "mou_document",
                    label: "Upload MOU (Photo/PDF)",
                  }}
                  formik={formik}
                  previews={previews}
                  setPreviews={setPreviews}
                />
              </Grid>
            </Grid>
          </Box>
        </CardContent>

        <CardActions sx={{ p: 3, justifyContent: "flex-end" }}>
          <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
            Submit Request
          </LoadingButton>
        </CardActions>
      </Form>
    </FormikProvider>
  );
};

export default LayoutOnboardingRequest;




// interface ProjectChecklist {
//   company_name: string;
//   project_name: string;
//   project_location: string;
//   highways?: string;
//   project_brochures?: string[] | File[];
//   project_videos?: string[] | File[];
//   linked_documents?: string[] | File[];
//   development_progress?: string;
//   is_own_land?: boolean;
//   is_own_venture?: boolean;
//   nala_conversion?: boolean;
//   registrations?: number;
//   bank_loan?: boolean;
//   associate_highest_commission?: number;
//   plp_margin?: number;
//   project_type?: 'Residential' | 'Commercial' | 'Mixed';
//   rera_number?: string;
//   rera_certificate?: string | File;
//   lp_number?: string;
//   mortgage_gauge_plots?: boolean;
//   hydra_rules?: boolean;
//   entry_timing?: string;
//   oc?: boolean;
//   link_documents?: string[] | File[];
//   property_documents?: string[] | File[];
//   aadhaar?: string | File;
//   pan?: string | File;
//   project_age?: number;
//   legal_opinion?: string;
//   photo?: string[] | File[];
//   oc_arrived?: boolean;
// }



// ALTER TABLE layout_requests
// ADD COLUMN IF NOT EXISTS project_location TEXT,
// ADD COLUMN IF NOT EXISTS highways TEXT,
// ADD COLUMN IF NOT EXISTS development_progress TEXT,
// ADD COLUMN IF NOT EXISTS is_own_land BOOLEAN,
// ADD COLUMN IF NOT EXISTS is_own_venture BOOLEAN,
// ADD COLUMN IF NOT EXISTS nala_conversion BOOLEAN,
// ADD COLUMN IF NOT EXISTS registrations INTEGER,
// ADD COLUMN IF NOT EXISTS bank_loan BOOLEAN,
// ADD COLUMN IF NOT EXISTS associate_highest_commission NUMERIC,
// ADD COLUMN IF NOT EXISTS plp_margin NUMERIC,
// ADD COLUMN IF NOT EXISTS project_type VARCHAR(20) CHECK (project_type IN ('Residential', 'Commercial', 'Mixed')),
// ADD COLUMN IF NOT EXISTS rera_number TEXT,
// ADD COLUMN IF NOT EXISTS mortgage_gauge_plots BOOLEAN,
// ADD COLUMN IF NOT EXISTS hydra_rules BOOLEAN,
// ADD COLUMN IF NOT EXISTS entry_timing TEXT,
// ADD COLUMN IF NOT EXISTS oc BOOLEAN,
// ADD COLUMN IF NOT EXISTS project_age INTEGER,
// ADD COLUMN IF NOT EXISTS legal_opinion TEXT,
// ADD COLUMN IF NOT EXISTS oc_arrived BOOLEAN;



